module.exports = "<p>transaction-report works!</p>\n"